import {readViewAsStateFromStorage} from './readViewAsStateFromStorage'

export function getViewAsToken(): string | null {
  return readViewAsStateFromStorage().token
}
